import React, { useState } from 'react';
import { BrowserRouter  as Router, Link } from "react-router-dom";
import Grid from '@material-ui/core/Grid';
import BookData from '../data/bookData.json'
import MenuComponent from '../Components/MenuComponent';
import Fade from 'react-reveal/Fade';
import ScrollUp from '../Components/ScrollUp';
import { useEffect } from 'react';
import Masonry from 'react-masonry-css';
import SearchIcon from '@material-ui/icons/Search';
import { styled, alpha } from '@material-ui/core';
import ElevateAppBar from '../Components/Header';
import RasterAd from '../Components/RasterAd';


const Quotes = () => {
    const [searchTerm, setSearchTerm] = useState('');

    const clearValue = () => {
        setSearchTerm('');
    }

    var visibility;
    
    
    const SearchIconWrapper = styled('div')(({ theme }) => ({
        paddingLeft: '10px',
        position: 'relative',
        pointerEvents: 'none',
        display: 'flex',
        alignItems: 'center',
        backgroundColor: 'var(--secondary)',
        justifyContent: 'left',
        borderRadius: '10px 0 0 10px',
      }));   

    useEffect(() => 
    window.scrollTo({top: 0, behavior: 'smooth'})
    
    );

    const breakPoints = {
        default: 3,
        1100: 2,
        700: 1
    }

    return ( 
        
        
        <div>
        <ElevateAppBar></ElevateAppBar>
        <Fade>
        
        
        </Fade>
        <br></br>

            <div className= 'search-bar'>
            <SearchIconWrapper>
              <SearchIcon />
            </SearchIconWrapper>
            <input
              type= 'text'
              value = {searchTerm}
              placeholder = 'Search by Quote, Title or Author'
              onChange = {(event) => {setSearchTerm(event.target.value)}}
            >
            
            </input>

            <button onClick={() => clearValue()} className='clear-search'><span className='clear-search-text'>x</span></button>
        </div>

            <br/>

        <div className= 'quotes'>

        <div className='detailAd' > <RasterAd></RasterAd></div>


        
        <Masonry breakpointCols={breakPoints}
                 className="my-masonry-grid"
                 columnClassName="my-masonry-grid_column">

        {BookData.slice(0).reverse().filter((val) => {

            if (searchTerm === ''){
                return val;
            }else if(val['quote-1'].toLowerCase().includes(searchTerm.toLowerCase())){
                
                return val['quote-1'];          

            }else if(val.author.toLowerCase().includes(searchTerm.toLowerCase())){
                return val;
            }else if(val.title.toLowerCase().includes(searchTerm.toLowerCase())){
                return val;
            };


                }) .map((book, index) => 

                <Fade>
                <Link to = {'/' + book.key + '/' + book.title.replace(/\s/g, "-")}>

                       <div className='quote-card'>

                            <div className='quote-header'>
                               <div className='quote-header-image'>
                                    <img src={book.cover}/>
                                </div>
                                <span>{book.title}</span>
                            </div>     

                            <h3 className='quote-card-content'>{book['quote-1']} </h3> 
                       </div>
                    
                </Link>
                </Fade>

               
                )}

                {BookData.slice(0).reverse().filter((val) => {

                if (searchTerm === ''){
                    return val;
                }else if(val['quote-2'].toLowerCase().includes(searchTerm.toLowerCase())){
                    return val['quote-2'];
                }else if(val.author.toLowerCase().includes(searchTerm.toLowerCase())){
                    return val;
                }else if(val.title.toLowerCase().includes(searchTerm.toLowerCase())){
                    return val;
                };


                }) .map((book, index) => 

                <Fade>
                <Link to = { book.key  }>
                    
                       <div className='quote-card'>

                            <div className='quote-header'>
                               <div className='quote-header-image'>
                                    <img src={book.cover}/>
                                </div>
                                <span>{book.title}</span>
                            </div>   

                            <h3 className='quote-card-content'>{book['quote-2']} </h3> 
                       </div>

                    
                </Link>
                </Fade>

               
                )}

                {BookData.slice(0).reverse().filter((val) => {

    if (searchTerm === ''){
        return val;
     }else if(val['quote-3'].toLowerCase().includes(searchTerm.toLowerCase())){
        return val['quote-3'];
    }else if(val.author.toLowerCase().includes(searchTerm.toLowerCase())){
                    return val;
                }else if(val.title.toLowerCase().includes(searchTerm.toLowerCase())){
                    return val;
                };


            }) .map((book, index) => 

                <Fade>
                 <Link to = { book.key  }>
    
                    <div className = 'quote-card' key = {index}>
                            <div className='quote-header'>
                               <div className='quote-header-image'>
                                    <img src={book.cover}/>
                                </div>
                                <span>{book.title}</span>
                            </div>   

                        <h3 >{book['quote-3']} </h3> 
                     </div> 

    
                </Link>
                 </Fade>
                    )}




            </Masonry>
        <ScrollUp/>

        
        </div>
        </div>
     );

     
}
 
export default Quotes;